import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Megaphone } from "lucide-react";
import api from "../lib/api";

export default function NewsTicker() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/ticker", { params: { active_only: true } }).then((r) => setItems(r.data)).catch(() => {});
  }, []);

  if (items.length === 0) return null;

  // Duplicate for seamless marquee
  const repeated = [...items, ...items, ...items];

  return (
    <div className="fixed top-0 inset-x-0 z-[60] bg-[#0B2A6B] text-white overflow-hidden h-9 border-b border-yellow-400/30">
      <div className="flex items-center h-full">
        <div className="shrink-0 bg-yellow-400 text-[#0B2A6B] px-4 h-full flex items-center gap-2 font-bold text-xs uppercase tracking-wider">
          <Megaphone className="h-3.5 w-3.5" />
          <span className="hidden sm:inline">Latest</span>
        </div>
        <div className="relative flex-1 overflow-hidden h-full">
          <div className="flex items-center gap-10 h-full w-max animate-marquee whitespace-nowrap">
            {repeated.map((t, i) => (
              <Link
                key={`${t.id}-${i}`}
                to={t.link || "#"}
                className="text-sm text-white/90 hover:text-yellow-400 transition inline-flex items-center gap-2"
              >
                <span className="h-1.5 w-1.5 rounded-full bg-yellow-400" />
                {t.message}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
